import React from 'react';
import CircularProgress from './CircularProgress';

interface LargeLoadingProps {
  open: boolean;
  message?: string;
}

const LargeLoading: React.FC<LargeLoadingProps> = ({ open, message = 'Ejecutando acción' }) => {
  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(4px)'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: '16px',
          padding: '2.5rem 3rem',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1.5rem',
          maxWidth: '90vw',
          minWidth: '320px'
        }}
      >
        <CircularProgress sizeRem={3} color="#6D57BC" />
        
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.75rem',
            textAlign: 'center'
          }}
        >
          <h3
            style={{
              margin: 0,
              fontSize: '1.25rem',
              fontWeight: 700,
              color: '#6D57BC'
            }}
          >
            {message}
          </h3>
          <p
            style={{
              margin: 0,
              fontSize: '0.875rem',
              color: '#6b7280',
              fontWeight: 500,
              lineHeight: 1.5
            }}
          >
            Por favor, no cierre esta página
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1rem',
            background: '#f3e8ff',
            borderRadius: '8px',
            border: '1px solid #c4b5fd'
          }}
        >
          <span style={{ fontSize: '1.25rem' }}>⏱️</span>
          <p
            style={{
              margin: 0,
              fontSize: '0.8rem',
              color: '#6D57BC',
              fontWeight: 700
            }}
          >
            Esta operación puede tardar unos momentos
          </p>
        </div>
      </div>
    </div>
  );
};

export default LargeLoading;

